import { combineReducers } from 'redux';

import { infosReducer } from './infos/reducer';
import type { EssentialFormState } from './model';
export const essentialFormReducer = combineReducers<EssentialFormState>({
  infos: infosReducer,
});
